import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import { ReactSession } from "react-client-session";
import { useLocation } from 'react-router-dom';
ReactSession.setStoreType("localStorage");


const WishList = () => {
    const [wishlistItems, setWishlistItems] = useState([]);
   

    
      // Wishlist
          const WishlistCount = () => {
              const items = JSON.parse(sessionStorage.getItem("wishlistItems")) || [];
              setWishlistItems(items);
          }
          useEffect(() => {
              WishlistCount();
              window.addEventListener('wishlistUpdated', WishlistCount);
              return () => {
                  window.removeEventListener('wishlistUpdated', WishlistCount);
              };
          }, []);
      
          // Remove wishlist
          const removeFromWishlist = (index) => {
              const updatedWishlist = [...wishlistItems];
              updatedWishlist.splice(index, 1);
              sessionStorage.setItem('wishlistItems', JSON.stringify(updatedWishlist));
              setWishlistItems(updatedWishlist);
              window.dispatchEvent(new Event('wishlistUpdated'));
          };

 




    return (
        <>
            <Header />
            <main class="main">
                <div className="breadcrumb-wrap" id="breadcrumb-margin">
                 <div className="banner" style={{minHeight:'10px'}}> 
                        <img class="bg-img bg-top" src="assets/images/inner-page/banner-p.webp" alt="banner" />

                        <div class="container-lg">
                            <div class="breadcrumb-box">
                                <div class="heading-box">
                                    <h1>My Wishlist</h1>
                                </div>
                                <ol class="breadcrumb">
                                    <li><a href="/">Home</a></li>

                                    <li>
                                        <a href=""><i data-feather="chevron-right"></i></a>
                                    </li>

                                    <li class="current"><a href="">Wishlist</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <section class="section-b-space wishlist-page">
                    <div class="container-lg">
                        
                        {wishlistItems.length === 0 ? (
                            <div className="empty-wishlist text-center py-5">
    
                                                 <p style={{ fontSize: '24px', fontWeight: '500', color: '#555' }}>
                                                   Your wishlist is empty
                                                 </p>
                                                 <p className="text-muted mb-4">
                                                   Save your favorite items here
                                                 </p>
                                                 <a 
                                                   href="/shop" 
                                                  class="btn btn-outline btn-sm addtocart-btn">Shop Now<i class="arrow"></i>
                                                 </a>
                                                 </div>
                        ) : (
                            <div className="row g-3 g-xl-4 ratio_asos">
                                {wishlistItems.map((wishlist, index) => (
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={index}>
                                        <div className="product-card product-wishlist">
                                            <div className="img-box">
                                                <a href={`singleproduct?id=${wishlist.id}`} className="primary-img"><img src={`https://api.welbeing.in/uploads/products/${wishlist.image}`} alt={wishlist.name} /></a>
                                                <button className="delete-button" onClick={(e) => { e.preventDefault(); removeFromWishlist(index);}}>
                                                    <i data-feather="x"></i>
                                                </button>
                                            </div>
                                            <div className="content-wrap">
                                                <div className="content-box">
                                                    <a href={`singleproduct?id=${wishlist.id}`}>
                                                        <h5>{wishlist.name}</h5>
                                                        <span>₹{wishlist.price}</span>
                                                    </a>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            </main >

            <Footer />

        </>
    )
}
export default WishList;
